import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { getWinClassName, betGroupProp } from "@/modules/commonMobile";

import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";

//Similar to m23 for More & Less Bet
export default class M25 extends React.PureComponent<IGameTableType> {
	numberColours = ["", "white", "green", "yellow", "red"];

	render() {
		const { langdata } = this.props;

		const gwcn = getWinClassName;
		const win = this.props.win ? Number(this.props.win) : null;

		const kwokNimSpan = (item) => {
			return (
				item[2] === "KWOK" ? [
					<span key={"kwok_1_" + item} className="kwok">KWOK </span>
					,
					<span key={"numbers_1_" + item} className={this.numberColours[item[0]]}>
						{item[0]}
					</span>
					,
					" & "
					,
					<span key={"numbers_2_" + item} className={this.numberColours[item[1]]}>
						{item[1]}
					</span>

				] : item[1] === "NIM" ? [
					<span key={"number_nim_1_" + item}>{item[0]}</span>
					,
					<span key={"nim_" + item} className="nim"> NIM </span>
					,
					<span key={"number_nim_2_" + item}>{item[2]}</span>
				] : null
			);
		};

		const ngatanDiv = (item) => {
			return (
				<div>
					<span className={this.numberColours[item[0]]}>
						{item[0]}
						{"\u00a0"}
					</span>
					<span className={this.numberColours[item[1]]}>
						{item[1]}
						{"\u00a0"}
					</span>
					<span className="nim">NGA TAN</span>
				</div>
			);
		};

		const betTemplate = (props, item, winCondition) => {
			const bet =
				item[1] === "NIM" ? `${item[0]}nim${item[2]}` :
					item[2] === "KWOK" ? `Kwok${item[0]}${item[1]}` : "";
			const group =
				item[1] === "NIM" ? item[1].toLowerCase() :
					item[2] === "KWOK" ? item[2].toLowerCase() : "";
			const betKey = `${bet}+${group}`

			return (
				<div key={"m25_" + betKey}
					className={"sl-bet" + gwcn(winCondition)}
					// bet={bet} group={group} pcode={props.pcode}
					{...betGroupProp(this, bet, group)}
					onClick={props.insertBet}>
					<div>
						{kwokNimSpan(item)}
					</div>

					<div className="bet-type">
						{
							item[1] === "NIM" ? "1:1.90" :
							item[2] === "KWOK" ? "1:0.95" : null
						}
					</div>

					<Chips betKey={betKey} {...commonChipProps} />
					<Tooltip {...commonTooltipProps} bet={props.bets[betKey]} />
				</div>
			);
		};

		//Both
		const mainGroupArray = [
			[2, 3, "KWOK"],
			[2, "NIM", 3],
			[2, "NIM", 4],
			[2, "NIM", 1],
			[1, 2, "KWOK"],

			[3, "NIM", 2],
			[3, "NIM", 1],
			[3, "NIM", 4],

			[3, 4, "KWOK"],
			[4, "NIM", 3],
			[4, "NIM", 2],
			[4, "NIM", 1],
			[1, 4, "KWOK"],

			[1, "NIM", 2],
			[1, "NIM", 3],
			[1, "NIM", 4]
		];

		const mainGroupAryWins = [
			win === 2 || win === 3,
			win === 2,
			win === 2,
			win === 2,
			win === 1 || win === 2,

			win === 3,
			win === 3,
			win === 3,

			win === 3 || win === 4,
			win === 4,
			win === 4,
			win === 4,
			win === 1 || win === 4,

			win === 1,
			win === 1,
			win === 1
		];



		//NGA TAN
		const NgaTanArray = [
			[2, 3, 1],
			[2, 4, 3],
			[3, 4, 2],
			[1, 3, 4],

			[1, 4, 3],
			[3, 4, 1],
			[1, 2, 4],
			[1, 4, 2],

			[2, 4, 1],
			[1, 2, 3],
			[1, 3, 2],
			[2, 3, 4]
		];

		const ngatanWins = [
			win === 2 || win === 3,
			win === 2 || win === 4,
			win === 3 || win === 4,
			win === 1 || win === 3,

			win === 1 || win === 4,
			win === 3 || win === 4,
			win === 1 || win === 2,
			win === 1 || win === 4,

			win === 2 || win === 4,
			win === 1 || win === 2,
			win === 1 || win === 3,
			win === 2 || win === 3
		];


		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		// use bottomClasses to mark the border
		// const bottomClasses = ["white", "yellow", "green", "red", "yellow", "white", "red", "green", "white", "yellow", "green", "red"]
		const bottomClasses = { 1: "white", 2: "green", 3: "yellow", 4: "red" };

		const mainGroupJSX = (
			<div className="main-group">
				<div className="top-group">
					{
						mainGroupArray.slice(0, 5).map((item, idx) =>
							betTemplate(this.props, item, mainGroupAryWins[idx])
						)
					}
				</div>

				<div className="middle-group">
					<div className="left">
						{
							mainGroupArray.slice(5, 8).map((item, idx) =>
								betTemplate(this.props, item, mainGroupAryWins[idx + 5])
							)
						}
					</div>

					<div className="middle">
						<div className="top">
							<div className={"sl-bet green" + gwcn(win === 2)}
								// bet="Fan2" group="fan" pcode={this.props.pcode}
								{...betGroupProp(this, "Fan2", "fan")}
								onClick={this.props.insertBet}>
								<div>
									<span className="nim">FAN </span>
									<span>2</span>
								</div>
								<div className="bet-type">
									1:2.85
								</div>

								<Chips betKey={`Fan2+fan`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Fan2+fan`]} />
							</div>
						</div>

						<div className="left">
							<div className={"sl-bet yellow" + gwcn(win === 3)}
								// bet="Fan3" group="fan" pcode={this.props.pcode}
								{...betGroupProp(this, "Fan3", "fan")}
								onClick={this.props.insertBet}>
								<div>
									<span className="nim">FAN </span>
									<span>3</span>
								</div>

								<div className="bet-type">
									1:2.85
								</div>

								<Chips betKey={`Fan3+fan`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Fan3+fan`]} />
							</div>
						</div>

						<div className="middle">
							<div className={"sl-bet odd" + gwcn(!!(win % 2))}
								// bet="odd" group="n50" pcode={this.props.pcode}
								{...betGroupProp(this, "odd", "n50")}
								onClick={this.props.insertBet}>
								<div>
									<span>ODD</span>
								</div>

								<div className="bet-type">
									1:0.95
								</div>

								<Chips betKey={`odd+n50`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`odd+n50`]} />
							</div>

							<div className={"sl-bet even" + gwcn(win && !(win % 2))}
								// bet="even" group="n50" pcode={this.props.pcode}
								{...betGroupProp(this, "even", "n50")}
								onClick={this.props.insertBet}>
								<div>
									<span>EVEN</span>
								</div>

								<div className="bet-type">
									1:0.95
								</div>

								<Chips betKey={`even+n50`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`even+n50`]} />
							</div>
						</div>

						<div className="right">
							<div className={"sl-bet white" + gwcn(win === 1)}
								// bet="Fan1" group="fan" pcode={this.props.pcode}
								{...betGroupProp(this, "Fan1", "fan")}
								onClick={this.props.insertBet}>
								<div>
									<span className="nim">FAN </span>
									<span>1</span>
								</div>

								<div className="bet-type">
									1:2.85
								</div>

								<Chips betKey={`Fan1+fan`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Fan1+fan`]} />
							</div>
						</div>

						<div className="bottom">
							<div className={"sl-bet red" + gwcn(win === 4)}
								// bet="Fan4" group="fan" pcode={this.props.pcode}
								{...betGroupProp(this, "Fan4", "fan")}
								onClick={this.props.insertBet}>
								<div>
									<span className="nim">FAN </span>
									<span>4</span>
								</div>

								<div className="bet-type">
									1:2.85
								</div>

								<Chips betKey={`Fan4+fan`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Fan4+fan`]} />
							</div>
						</div>
					</div>

					<div className="left">
						{
							mainGroupArray.slice(13, 16).map((item, idx) =>
								betTemplate(this.props, item, mainGroupAryWins[idx + 13])
							)
						}
					</div>
				</div>

				<div className="bottom-group">
					{
						mainGroupArray.slice(8, 13).map((item, idx) =>
							betTemplate(this.props, item, mainGroupAryWins[idx + 8])
						)
					}
				</div>
			</div>
		);

		//Portrait templates
		const mainSimplerGroupArray = [
			//left
			[2, 3, "KWOK"],
			[3, "NIM", 2],
			[3, "NIM", 1],
			[3, "NIM", 4],
			[3, 4, "KWOK"],

			//top
			[2, "NIM", 3],
			[2, "NIM", 4],
			[2, "NIM", 1],

			//right
			[1, 2, "KWOK"],
			[1, "NIM", 2],
			[1, "NIM", 3],
			[1, "NIM", 4],
			[1, 4, "KWOK"],

			//bottom
			[4, "NIM", 3],
			[4, "NIM", 2],
			[4, "NIM", 1]
		];

		const mainSimpleGroupWins = [
			win === 2 || win === 3,
			win === 3,
			win === 3,
			win === 3,
			win === 3 || win === 4,

			win === 2,
			win === 2,
			win === 2,

			win === 1 || win === 2,
			win === 1,
			win === 1,
			win === 1,
			win === 1 || win === 4,

			win === 4,
			win === 4,
			win === 4
		];

		//Portrait Sides
		const processSimplerSidesGroup = (item, idx) => {
			const isKwok = item[2] === "KWOK";

			const betBet = isKwok ? ("Kwok" + item[0] + item[1]) : item.join("").toLowerCase();
			const betGroup = isKwok ? "kwok" : "nim";

			const betKey = betBet + "+" + betGroup;

			return (
				<div key={"pSSG_" + betKey}
					className={`sl-bet col-xs-12 sl-baccarat-bet-blue ${isKwok ? "taller" : ""}` + gwcn(mainSimpleGroupWins[idx])}
					// bet={betBet} group={betGroup} pcode={this.props.pcode}
					{...betGroupProp(this, betBet, betGroup)}
					onClick={this.props.insertBet}>

					<div>{kwokNimSpan(item)}</div>
					<div className="bet-type">
						{isKwok ? "1:0.95" : "1:1.9"}
					</div>

					<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
				</div>
			);
		};

		//Portrait Top & Bottom Nim
		const processSimplerTopBottomGroup = (item, idx) => {
			const betBet = item.join("").toLowerCase();
			const betKey = betBet + "+nim";

			return (
				<div key={"pSTBG_" + betKey}
					className={"sl-bet col-xs-4 sl-baccarat-bet-blue" + gwcn(mainSimpleGroupWins[idx])}
					// bet={betBet} group="nim" pcode={this.props.pcode}
					{...betGroupProp(this, betBet, "nim")}
					onClick={this.props.insertBet}>
					<div>{kwokNimSpan(item)}</div>
					<div className="bet-type">1:1.9</div>
					<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
				</div>
			);
		};

		const mainSimplerGroupJSX = (
			<div className="row">
				<div className="col-20p">
					{
						//Left part
						mainSimplerGroupArray.slice(0, 5).map((item, idx) => {
							return processSimplerSidesGroup(item, idx);
						})
					}
				</div>

				<div className="col-60p">
					<div className="row">
						{
							//Top
							mainSimplerGroupArray.slice(5, 8).map((item, idx) => {
								return processSimplerTopBottomGroup(item, idx + 5);
							})
						}
					</div>

					<div className="row middle">
						<div className={"sl-bet col-xs-4 top green" + gwcn(win === 2)}
							// bet="Fan2" group="fan" pcode={this.props.pcode}
							{...betGroupProp(this, "Fan2", "fan")}
							onClick={this.props.insertBet}>
							<div>
								<span>FAN 2</span>
							</div>
							<div className="bet-type">1:2.85</div>
							<Chips betKey="Fan2+fan" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
						</div>

						<div className="middle">
							<div className={"sl-bet col-xs-4 left yellow" + gwcn(win === 3)}
								// bet="Fan3" group="fan" pcode={this.props.pcode}
								{...betGroupProp(this, "Fan3", "fan")}
								onClick={this.props.insertBet}>
								<div>
									<span>FAN 3</span>
								</div>
								<div className="bet-type">1:2.85</div>
								<Chips betKey="Fan3+fan" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							</div>

							<div className={"sl-bet col-xs-4 middle odd" + gwcn(!!(win % 2))}
								// bet="odd" group="n50" pcode={this.props.pcode}
								{...betGroupProp(this, "odd", "n50")}
								onClick={this.props.insertBet}>
								{langdata["txt_odd"]}
								<div className="bet-type">1:0.95</div>
								<Chips betKey="odd+n50" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							</div>

							<div className={"sl-bet col-xs-4 middle even" + gwcn(win && !(win % 2))}
								// bet="even" group="n50" pcode={this.props.pcode}
								{...betGroupProp(this, "even", "n50")}
								onClick={this.props.insertBet}>
								{langdata["txt_even"]}
								<div className="bet-type">1:0.95</div>
								<Chips betKey="even+n50" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							</div>

							<div className={"sl-bet col-xs-4 right white" + gwcn(win === 1)}
								// bet="Fan1" group="fan" pcode={this.props.pcode}
								{...betGroupProp(this, "Fan1", "fan")}
								onClick={this.props.insertBet}>
								<div>
									<span>FAN 1</span>
								</div>
								<div className="bet-type">1:2.85</div>
								<Chips betKey="Fan1+fan" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							</div>
						</div>

						<div className={"sl-bet col-xs-4 bottom red" + gwcn(win === 4)}
							// bet="Fan4" group="fan" pcode={this.props.pcode}
							{...betGroupProp(this, "Fan4", "fan")}
							onClick={this.props.insertBet}>
							<div>
								<span>FAN 4</span>
							</div>
							<div className="bet-type">1:2.85</div>
							<Chips betKey="Fan4+fan" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
						</div>
					</div>

					<div className="row">
						{
							//Bottom
							mainSimplerGroupArray.slice(13, 16).map((item, idx) =>
								processSimplerTopBottomGroup(item, idx + 13)
							)
						}
					</div>
				</div>


				<div className="col-20p">
					{
						//Left part
						mainSimplerGroupArray.slice(8, 13).map((item, idx) =>
							processSimplerSidesGroup(item, idx + 8)
						)
					}
				</div>
			</div>
		);

		return this.props.portrait ? (
			this.props.completeTable ? (
				<div className="sl-table m25 full_v3">
					{
						[
							[[1, 2, 3], [1, 2, 4]],
							[[2, 3, 4], [1, 3, 4]]
						].map((largeGroup, largeGroupIdx) =>
							<div className="row" key={"large_group_" + largeGroupIdx}>
								{
									largeGroup.map((smallGroup, smallGroupIdx) => {
										const bet = `Shensamhong${smallGroup.join("")}`;
										const group = `shensamhong`;
										const betKey = `${bet}+${group}`;

										return (
											<div className={`sl-bet col-xs-6 shensamhong ssh${smallGroup.join("")}` + gwcn(smallGroup.indexOf(win) >= 0)}
												key={"large_group_" + largeGroupIdx + "_small_group_" + smallGroupIdx}
												// bet={bet} group={group} pcode={this.props.pcode}
												{...betGroupProp(this, bet, group)}
												onClick={this.props.insertBet}>
												<div>
													<div>SHEN SAM HONG</div>
													<div>{smallGroup.join(" ")}</div>
												</div>
												<div className="bet-type">0:3167</div>
												<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
											</div>
										);
									})
								}
							</div>
						)
					}

					{mainSimplerGroupJSX}

					{
						//Clone of landscape
						NgaTanArray.map((item, idx) => {
							const bet = `Ngatan${item.join("")}`
							const group = "ngatan";
							const betKey = `${bet}+${group}`;

							return (
								<div className={`sl-bet ngatan ${bottomClasses[item[2]]}` + gwcn(ngatanWins[idx])}
									key={"ngatan_" + idx}
									// bet={bet} group={group} pcode={this.props.pcode}
									{...betGroupProp(this, bet, group)}
									onClick={this.props.insertBet}>
									{
										ngatanDiv(item)
									}

									<div className="bet-type">
										1:0.47
										</div>

									<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
								</div>
							);
						})
					}
				</div>
			) : (
					<div className="sl-table m25 simpler">
						{mainSimplerGroupJSX}
					</div>
				)
		) :
			this.props.maximised ? (
				this.props.completeTable ?
					<div className="m25 complete">
						<div className="left-group">
							<div className={"sl-bet shensamhong ssh123" + gwcn([1, 2, 3].indexOf(win) >= 0)}
								// bet="Shensamhong123" group="shensamhong" pcode={this.props.pcode}
								{...betGroupProp(this, "Shensamhong123", "shensamhong")}
								onClick={this.props.insertBet}>
								<div>
									<div>SHEN SAM HONG</div>
									<div>1 2 3</div>
								</div>

								<div className="bet-type">
									0.31
								</div>

								<Chips betKey={`Shensamhong123+shensamhong`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Shensamhong123+shensamhong`]} />
							</div>

							<div className={"sl-bet shensamhong ssh234" + gwcn([2, 3, 4].indexOf(win) >= 0)}
								// bet="Shensamhong234" group="shensamhong" pcode={this.props.pcode}
								{...betGroupProp(this, "Shensamhong234", "shensamhong")}
								onClick={this.props.insertBet}>
								<div>
									<div>SHEN SAM HONG</div>
									<div>2 3 4</div>
								</div>

								<div className="bet-type">
									0.31
								</div>

								<Chips betKey={`Shensamhong234+shensamhong`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Shensamhong234+shensamhong`]} />
							</div>
						</div>

						{mainGroupJSX}

						<div className="right-group">
							<div className={"sl-bet shensamhong ssh124" + gwcn([1, 2, 4].indexOf(win) >= 0)}
								// bet="Shensamhong124" group="shensamhong" pcode={this.props.pcode}
								{...betGroupProp(this, "Shensamhong124", "shensamhong")}
								onClick={this.props.insertBet}>
								<div>
									<div>SHEN SAM HONG</div>
									<div>1 2 4</div>
								</div>

								<div className="bet-type">
									0.31
								</div>

								<Chips betKey={`Shensamhong124+shensamhong`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Shensamhong124+shensamhong`]} />
							</div>

							<div className={"sl-bet shensamhong ssh134" + gwcn([1, 3, 4].indexOf(win) >= 0)}
								// bet="Shensamhong134" group="shensamhong" pcode={this.props.pcode}
								{...betGroupProp(this, "Shensamhong134", "shensamhong")}
								onClick={this.props.insertBet}>
								<div>
									<div>SHEN SAM HONG</div>
									<div>1 3 4</div>
								</div>

								<div className="bet-type">
									0.31
								</div>

								<Chips betKey={`Shensamhong134+shensamhong`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`Shensamhong134+shensamhong`]} />
							</div>
						</div>

						<div className="bottom-group">
							{
								NgaTanArray.map((item, idx) => {
									const bet = `Ngatan${item.join("")}`
									const group = "ngatan";
									const betKey = `${bet}+${group}`;

									return (
										<div className={`sl-bet ngatan ${bottomClasses[item[2]]}` + gwcn(ngatanWins[idx])}
											key={"ngatan_bottom_" + idx}
											{...betGroupProp(this, bet, group)}
											// bet={bet} group={group} pcode={this.props.pcode}
											onClick={this.props.insertBet}>
											{
												ngatanDiv(item)
											}

											<div className="bet-type">
												1:0.47
										</div>

											<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
										</div>
									);
								})
							}
						</div>
					</div>
					:
					<div className="m25 simpler">
						{mainGroupJSX}
					</div>
			) :
				<div className="m25 complete">
					{mainGroupJSX}
				</div>
			;
	}
}